import {
  Card,
  VStack,
  Flex,
  Skeleton,
  SkeletonCircle,
  useColorModeValue,
  Text,
} from "@chakra-ui/react";
import { colors } from "@/components/Theme/colors";

const ChannelLeadersListSkeleton = () => {
  const borderColor = useColorModeValue(colors.neutral[100], "gray.700");
  const cardBg = useColorModeValue("white", "gray.800");

  return (
    <Card
      bg={cardBg}
      borderRadius="6px"
      boxShadow="md"
      border="1px solid"
      shadow={0}
      borderColor={borderColor}
      maxW={{ base: "100%", md: "330px" }}
      width={{ base: "100%", md: "330px" }}
      p="24px"
    >
      <Text
        as="div"
        variant="body"
        fontWeight="600"
        mb="16px"
        textAlign="center"
      >
        <Skeleton height="20px" w="200px" mx="auto" />
      </Text>
      <VStack spacing={4} align="stretch">
        {Array.from({ length: 1 }).map((_, i) => (
          <Flex
            key={i}
            align="center"
            gap={3}
            p={3}
            borderRadius="6px"
            border="1px solid"
            borderColor={borderColor}
          >
            <SkeletonCircle size="12" />
            <Skeleton height="16px" w="60%" />
          </Flex>
        ))}
      </VStack>
    </Card>
  );
};

export default ChannelLeadersListSkeleton;
